/* eslint-disable */
/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  RegimeCellMetricsRegimeDto,
  RegimeCopyRequest,
  RegimeCreateRequest,
  RegimeDto,
  RegimeUpdateRequest,
} from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType, BodyType } from '../../orval-mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN, ROLE_USER, ROLE_INTERNAL_USER**<br /><br />Returns regimes for the aid model
 * @summary Get regimes
 */
export const getRegimes = (
  userId: string,
  modelId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<RegimeDto[]>(
    {
      url: `/api/${userId}/aid-models/${modelId}/regimes`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getGetRegimesQueryKey = (userId: string, modelId: number) => {
  return [`/api/${userId}/aid-models/${modelId}/regimes`] as const;
};

export const getGetRegimesQueryOptions = <
  TData = Awaited<ReturnType<typeof getRegimes>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  modelId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRegimes>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRegimesQueryKey(userId, modelId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRegimes>>> = ({
    signal,
  }) => getRegimes(userId, modelId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(userId && modelId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getRegimes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRegimesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRegimes>>
>;
export type GetRegimesQueryError = ErrorType<unknown>;

export function useGetRegimes<
  TData = Awaited<ReturnType<typeof getRegimes>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  modelId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRegimes>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRegimes>>,
          TError,
          Awaited<ReturnType<typeof getRegimes>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRegimes<
  TData = Awaited<ReturnType<typeof getRegimes>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  modelId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRegimes>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRegimes>>,
          TError,
          Awaited<ReturnType<typeof getRegimes>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRegimes<
  TData = Awaited<ReturnType<typeof getRegimes>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  modelId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRegimes>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get regimes
 */

export function useGetRegimes<
  TData = Awaited<ReturnType<typeof getRegimes>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  modelId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRegimes>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetRegimesQueryOptions(userId, modelId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN, ROLE_USER, ROLE_INTERNAL_USER**<br /><br />Creates a new regime
 * @summary Create regime
 */
export const createRegime = (
  userId: string,
  modelId: number,
  regimeCreateRequest: BodyType<RegimeCreateRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<RegimeDto>(
    {
      url: `/api/${userId}/aid-models/${modelId}/regimes`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: regimeCreateRequest,
      signal,
    },
    options
  );
};

export const getCreateRegimeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createRegime>>,
    TError,
    { userId: string; modelId: number; data: BodyType<RegimeCreateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createRegime>>,
  TError,
  { userId: string; modelId: number; data: BodyType<RegimeCreateRequest> },
  TContext
> => {
  const mutationKey = ['createRegime'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createRegime>>,
    { userId: string; modelId: number; data: BodyType<RegimeCreateRequest> }
  > = (props) => {
    const { userId, modelId, data } = props ?? {};

    return createRegime(userId, modelId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateRegimeMutationResult = NonNullable<
  Awaited<ReturnType<typeof createRegime>>
>;
export type CreateRegimeMutationBody = BodyType<RegimeCreateRequest>;
export type CreateRegimeMutationError = ErrorType<unknown>;

/**
 * @summary Create regime
 */
export const useCreateRegime = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createRegime>>,
      TError,
      { userId: string; modelId: number; data: BodyType<RegimeCreateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createRegime>>,
  TError,
  { userId: string; modelId: number; data: BodyType<RegimeCreateRequest> },
  TContext
> => {
  return useMutation(getCreateRegimeMutationOptions(options), queryClient);
};
/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN, ROLE_USER, ROLE_INTERNAL_USER**<br /><br />Creates a deep copy of an existing regime with a new name
 * @summary Copy regime
 */
export const copyRegime = (
  userId: string,
  modelId: number,
  id: number,
  regimeCopyRequest: BodyType<RegimeCopyRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<RegimeDto>(
    {
      url: `/api/${userId}/aid-models/${modelId}/regimes/${id}/copy`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: regimeCopyRequest,
      signal,
    },
    options
  );
};

export const getCopyRegimeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof copyRegime>>,
    TError,
    {
      userId: string;
      modelId: number;
      id: number;
      data: BodyType<RegimeCopyRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof copyRegime>>,
  TError,
  {
    userId: string;
    modelId: number;
    id: number;
    data: BodyType<RegimeCopyRequest>;
  },
  TContext
> => {
  const mutationKey = ['copyRegime'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof copyRegime>>,
    {
      userId: string;
      modelId: number;
      id: number;
      data: BodyType<RegimeCopyRequest>;
    }
  > = (props) => {
    const { userId, modelId, id, data } = props ?? {};

    return copyRegime(userId, modelId, id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CopyRegimeMutationResult = NonNullable<
  Awaited<ReturnType<typeof copyRegime>>
>;
export type CopyRegimeMutationBody = BodyType<RegimeCopyRequest>;
export type CopyRegimeMutationError = ErrorType<unknown>;

/**
 * @summary Copy regime
 */
export const useCopyRegime = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof copyRegime>>,
      TError,
      {
        userId: string;
        modelId: number;
        id: number;
        data: BodyType<RegimeCopyRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof copyRegime>>,
  TError,
  {
    userId: string;
    modelId: number;
    id: number;
    data: BodyType<RegimeCopyRequest>;
  },
  TContext
> => {
  return useMutation(getCopyRegimeMutationOptions(options), queryClient);
};
/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN, ROLE_USER, ROLE_INTERNAL_USER**<br /><br />Returns a single regime by its ID
 * @summary Get regime by ID
 */
export const getRegimeById = (
  userId: string,
  modelId: number,
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<RegimeDto>(
    {
      url: `/api/${userId}/aid-models/${modelId}/regimes/${id}`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getGetRegimeByIdQueryKey = (
  userId: string,
  modelId: number,
  id: number
) => {
  return [`/api/${userId}/aid-models/${modelId}/regimes/${id}`] as const;
};

export const getGetRegimeByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getRegimeById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  modelId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRegimeById>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRegimeByIdQueryKey(userId, modelId, id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRegimeById>>> = ({
    signal,
  }) => getRegimeById(userId, modelId, id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(userId && modelId && id),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getRegimeById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRegimeByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRegimeById>>
>;
export type GetRegimeByIdQueryError = ErrorType<unknown>;

export function useGetRegimeById<
  TData = Awaited<ReturnType<typeof getRegimeById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  modelId: number,
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRegimeById>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRegimeById>>,
          TError,
          Awaited<ReturnType<typeof getRegimeById>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRegimeById<
  TData = Awaited<ReturnType<typeof getRegimeById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  modelId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRegimeById>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRegimeById>>,
          TError,
          Awaited<ReturnType<typeof getRegimeById>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRegimeById<
  TData = Awaited<ReturnType<typeof getRegimeById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  modelId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRegimeById>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get regime by ID
 */

export function useGetRegimeById<
  TData = Awaited<ReturnType<typeof getRegimeById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  modelId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRegimeById>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetRegimeByIdQueryOptions(
    userId,
    modelId,
    id,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN, ROLE_USER, ROLE_INTERNAL_USER**<br /><br />Deletes a regime by its ID
 * @summary Delete regime
 */
export const deleteRegime = (
  userId: string,
  modelId: number,
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<void>(
    {
      url: `/api/${userId}/aid-models/${modelId}/regimes/${id}`,
      method: 'DELETE',
      signal,
    },
    options
  );
};

export const getDeleteRegimeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteRegime>>,
    TError,
    { userId: string; modelId: number; id: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteRegime>>,
  TError,
  { userId: string; modelId: number; id: number },
  TContext
> => {
  const mutationKey = ['deleteRegime'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteRegime>>,
    { userId: string; modelId: number; id: number }
  > = (props) => {
    const { userId, modelId, id } = props ?? {};

    return deleteRegime(userId, modelId, id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteRegimeMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteRegime>>
>;

export type DeleteRegimeMutationError = ErrorType<unknown>;

/**
 * @summary Delete regime
 */
export const useDeleteRegime = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteRegime>>,
      TError,
      { userId: string; modelId: number; id: number },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteRegime>>,
  TError,
  { userId: string; modelId: number; id: number },
  TContext
> => {
  return useMutation(getDeleteRegimeMutationOptions(options), queryClient);
};
/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN, ROLE_USER, ROLE_INTERNAL_USER**<br /><br />Updates an existing regime
 * @summary Update regime
 */
export const updateRegime = (
  userId: string,
  modelId: number,
  id: number,
  regimeUpdateRequest: BodyType<RegimeUpdateRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<RegimeDto>(
    {
      url: `/api/${userId}/aid-models/${modelId}/regimes/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: regimeUpdateRequest,
      signal,
    },
    options
  );
};

export const getUpdateRegimeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateRegime>>,
    TError,
    {
      userId: string;
      modelId: number;
      id: number;
      data: BodyType<RegimeUpdateRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateRegime>>,
  TError,
  {
    userId: string;
    modelId: number;
    id: number;
    data: BodyType<RegimeUpdateRequest>;
  },
  TContext
> => {
  const mutationKey = ['updateRegime'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateRegime>>,
    {
      userId: string;
      modelId: number;
      id: number;
      data: BodyType<RegimeUpdateRequest>;
    }
  > = (props) => {
    const { userId, modelId, id, data } = props ?? {};

    return updateRegime(userId, modelId, id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateRegimeMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateRegime>>
>;
export type UpdateRegimeMutationBody = BodyType<RegimeUpdateRequest>;
export type UpdateRegimeMutationError = ErrorType<unknown>;

/**
 * @summary Update regime
 */
export const useUpdateRegime = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateRegime>>,
      TError,
      {
        userId: string;
        modelId: number;
        id: number;
        data: BodyType<RegimeUpdateRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateRegime>>,
  TError,
  {
    userId: string;
    modelId: number;
    id: number;
    data: BodyType<RegimeUpdateRequest>;
  },
  TContext
> => {
  return useMutation(getUpdateRegimeMutationOptions(options), queryClient);
};
/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN, ROLE_USER, ROLE_INTERNAL_USER**<br /><br />Returns the per-cell metrics grid (need-rank bucket -> academic-rank row) shown under this regime's award-calculation matrix. Each row carries a current-year set (dataset actuals) and a future-year set (projected engine output) of net cost, net tuition, average institutional aid, yield, admits, and enrolls. Dollar metrics are unweighted means over the matrix students in the cell, so they do not reconcile with the probability-weighted Aid Results band.
 * @summary Get per-cell regime metrics
 */
export const getRegimeComparison = (
  userId: string,
  modelId: number,
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<RegimeCellMetricsRegimeDto>(
    {
      url: `/api/${userId}/aid-models/${modelId}/regimes/${id}/comparison`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getGetRegimeComparisonQueryKey = (
  userId: string,
  modelId: number,
  id: number
) => {
  return [
    `/api/${userId}/aid-models/${modelId}/regimes/${id}/comparison`,
  ] as const;
};

export const getGetRegimeComparisonQueryOptions = <
  TData = Awaited<ReturnType<typeof getRegimeComparison>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  modelId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRegimeComparison>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetRegimeComparisonQueryKey(userId, modelId, id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRegimeComparison>>
  > = ({ signal }) =>
    getRegimeComparison(userId, modelId, id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(userId && modelId && id),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getRegimeComparison>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRegimeComparisonQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRegimeComparison>>
>;
export type GetRegimeComparisonQueryError = ErrorType<unknown>;

export function useGetRegimeComparison<
  TData = Awaited<ReturnType<typeof getRegimeComparison>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  modelId: number,
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRegimeComparison>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRegimeComparison>>,
          TError,
          Awaited<ReturnType<typeof getRegimeComparison>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRegimeComparison<
  TData = Awaited<ReturnType<typeof getRegimeComparison>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  modelId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRegimeComparison>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRegimeComparison>>,
          TError,
          Awaited<ReturnType<typeof getRegimeComparison>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRegimeComparison<
  TData = Awaited<ReturnType<typeof getRegimeComparison>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  modelId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRegimeComparison>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get per-cell regime metrics
 */

export function useGetRegimeComparison<
  TData = Awaited<ReturnType<typeof getRegimeComparison>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  modelId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRegimeComparison>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetRegimeComparisonQueryOptions(
    userId,
    modelId,
    id,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
